// extracted by mini-css-extract-plugin
export var intro = "headline-module--intro--677a3";
export var label = "headline-module--label--0e902";